/**
 * @项目名称: work
 * @功能名称: 自动替换二级、三级域名
 * @文件名称: replaceDomain
 * cardloan.xiaoying.com
 *   1级       2级    3级
 */

 import url from 'url'
 const twoDomainList = ['xiaoying']  // 需要被替换的二级域名列表
 const threeDomainList = ['cardloan', 'login', 'register', 'opengw', 'wallet', 'report', 'track', 'r', 'push', 'account', 'www', 'growth', 'ldp', 'bjtestcardloan', 'bjtestldp','aso']  // 需要被替换的三级域名列表
 const pageHostStr = location.host || ''
 const pageHostList = pageHostStr.split('.')
 const mockHostList = ['opengw.xiaoying.com']
 const testDomainList = ['cardloan-uat','cardloan-uat-test1','cardloan-uat-test2','cardloan-uat-test3','cardloan-uat-test4'] // 101/20 环境
 const threeTestDomainList = ['cardloan', 'login', 'register', 'opengw','growth', 'ldp','account', 'aso' ]

 export default function replaceDomain (urlString, bool) {
   const urlObj = url.parse(urlString)
   const postHostStr = urlObj.host

   if(process.env.VUE_APP_MODE === 'mock' && mockHostList.includes(urlObj.host)) {
    return urlObj.path
   }

   // 忽略域名相同
   if(pageHostStr === postHostStr){
     return urlString
   }

   // 忽略IP请求方式
   if(!(postHostStr && !/^[\d|.]+$/g.test(postHostStr) && !/^[\d|.]+$/g.test(pageHostStr) && pageHostList.length === 3)){
     return urlString
   }

   const postHostList = postHostStr.split('.')
   // 替换三级域名，针对cardloan.xiaoying.com被封堵的情况
   // 如果一级、二级相同，三级不在本地预设
   if(postHostList[0] === 'cardloan' && !threeDomainList.includes(pageHostList[0]) && pageHostList[1] === postHostList[1] && pageHostList[2] === postHostList[2]) {
    postHostList[0] = pageHostList[0]
    }

    // 外部使用内部测试环境cardloan-uat-test1.xiaoying.com
    if(testDomainList.includes(pageHostList[0]) && threeTestDomainList.includes(postHostList[0])){
      postHostList[0] = `${postHostList[0]}${pageHostList[0].slice(8)}`
    }

   // 替换二级域名
   // 如果一级在预设域名内、三级相同，二级不相同且请求的存在预设的二级域名内，则替换请求的二级为本地的二级
   if(threeDomainList.includes(postHostList[0]) && twoDomainList.includes(postHostList[1]) && pageHostList[2] === postHostList[2]) {
     postHostList[1] = pageHostList[1]
   }

   urlObj.host = postHostList.join('.')
   return url.format(urlObj)
 }
